import { render, staticRenderFns } from "./CardConsumption.vue?vue&type=template&id=04f51697&scoped=true&"
import script from "./CardConsumption.vue?vue&type=script&lang=js&"
export * from "./CardConsumption.vue?vue&type=script&lang=js&"
import style0 from "./CardConsumption.vue?vue&type=style&index=0&id=04f51697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f51697",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemTitle,VSpacer})
